export default __webpack_public_path__ + "static/media/splash.ef29560a.png";